export const getFormattedLocale = (locale: string | null): string | undefined => {
  let formattedLocale = locale?.indexOf('-') !== -1 ? locale?.split('-').join('_') : locale;
  formattedLocale = (formattedLocale && formattedLocale?.toUpperCase()) || 'EN_US';
  return formattedLocale;
};
